module.exports = __webpack_public_path__ + "static/media/Q_3.b3e7e2da.png";